import React from 'react';
import cn from 'classnames';
import style from './header.mod.scss';
import MenuItem from '../global/menu/menu-item';
import Container from '../layout/container/container';
import Burger from '../global/icons/burger';
import Logo from '../logo/logo';
import { useMenu } from '../../context/MenuContext';
import { Link } from 'gatsby';

const Header = ({ links }) => {
  const { isMenuOpen, toggleMenu } = useMenu();

  const classes = cn(style.header, {
    [style[`header--open`]]: isMenuOpen,
  });

  const lastLink = links[links.length - 1];
  lastLink.button = true;

  return (
    <nav className={classes}>
      <Container size="none" gutters>
        <div className={style.header__wrapper}>
          <div className={style.header__logo}>
            <Link to='/' name="Strive Digital Logo">
              <Logo />
            </Link>
          </div>
          <div className={style.header__navigation}>
            <ul className={style.header__links}>
              {links.map((link, id) => (
                <MenuItem {...link} key={id} />
              ))}
            </ul>
          </div>
          <div
            className={style.header__burger}
            onClick={() => toggleMenu(!isMenuOpen)}
          >
            <Burger isOpen={isMenuOpen} />
          </div>
        </div>
      </Container>
    </nav>
  );
};

export default Header;

{
  /* <AnimatePresence>
  {isMenuOpen && (
    <motion.div
      className={style.mobile}
      initial={{ x: -700 }}
      animate={{ x: 0 }}
      exit={{ x: -700 }}
      transition={{ ease: 'easeInOut' }}
    >
      <Container gutters>
        <Spacing pt={2}>
          <div className={style.mobile__content}>
            <p>Item</p>
            <p>Item 2</p>
            <p>Item 3</p>
          </div>
        </Spacing>
      </Container>
    </motion.div>
  )}
</AnimatePresence> */
}
